import "moment/locale/it"
import { PlayerRole } from "types/player"
import { Col, Row } from "react-bootstrap"
import { PlayerRetiredStats } from "@components/PlayerRetiredStats/RetiredPlayerStats"
import { RetiredPlayerTypeParameterFlat } from "types/retiredPlayerStats"

export function PlayerTypeRetiredStats({ role, stats }: { role: PlayerRole; stats: RetiredPlayerTypeParameterFlat }) {
  const minutes = stats.parameters.find((parameter) => parameter.code === "MIN")?.value || 0
  const assists = stats.parameters.find((parameter) => parameter.code === "ASS_V")?.value || 0

  const yellowCards = stats.parameters.find((parameter) => parameter.code === "CRT_G")?.value || 0
  const redCards = stats.parameters.find((parameter) => parameter.code === "CRT_R")?.value || 0

  const goals = stats.parameters.find((parameter) => parameter.code === "GOL")?.value || 0
  const penaltyGoals = stats.parameters.find((parameter) => parameter.code === "GOL_R")?.value || 0

  const matchesPlayed = stats.parameters.find((parameter) => parameter.code === "PG")?.value || 0
  const startingElevenMatches = stats.parameters.find((parameter) => parameter.code === "PG_T")?.value || 0

  let playerCompetitionSeasonStatsComponent

  switch (role) {
    case "goalkeeper":
    case "defender":
    case "midfielder":
    case "forward":
      playerCompetitionSeasonStatsComponent = (
        <PlayerRetiredStats
          minutes={minutes}
          assists={assists}
          yellowCards={yellowCards}
          redCards={redCards}
          goals={goals}
          penaltyGoals={penaltyGoals}
          matchesPlayed={matchesPlayed}
          startingElevenMatches={startingElevenMatches}
        />
      )
      break

    default:
      playerCompetitionSeasonStatsComponent = <></>
  }

  return (
    <>
      <Col>
        <Row>{playerCompetitionSeasonStatsComponent}</Row>
      </Col>
    </>
  )
}
